module.exports = __webpack_public_path__ + "static/media/twitImage.2449dd05.jpeg";